/**
 * End User Response Styles
 */

import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px;
  max-width: 900px;
  margin: 0 auto;
  min-height: 80vh;
`;

export const Header = styled.div`
  margin-bottom: 32px;
  text-align: center;
`;

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 8px;
  color: ${({ theme }) => theme.text?.primary || '#fff'};
`;

export const InfoSection = styled.div`
  background: ${({ theme }) => theme.background?.primary || 'rgba(0, 0, 0, 0.2)'};
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 24px;
  border-left: 4px solid ${({ theme }) => theme.primary || '#FFC700'};
`;

export const ContentSection = styled.div`
  background: ${({ theme }) => theme.background?.secondary || 'rgba(255, 255, 255, 0.05)'};
  border-radius: 12px;
  padding: 32px;
  min-height: 400px;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid ${({ theme }) => theme.text?.secondary || 'rgba(255, 255, 255, 0.1)'};

  @media (max-width: 768px) {
    flex-direction: column-reverse;

    button {
      width: 100%;
    }
  }
`;
